export default [
	{
		name: '创作台',
		path: '/create',
		routes: [
			{
				name: 'AI商拍图',
				path: '/create/product-main-image',
				component: './create/productMainImage',
				meta: {
					hideNav: true,
					showWorkbench: true,
					hideBorder: true,
					crumb: 'create',
					img: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/chuangzuotairukou-AIshangpaitu@2x.png',
					subLabel: '媲美专业产品摄影',
					menuIcon: 'AIshangpintu',
				},
			},
			{
				name: 'AI商品海报',
				path: '/create/marketing-poster',
				component: './create/marketingPoster',
				meta: {
					hideNav: true,
					showWorkbench: true,
					hideBorder: true,
					crumb: 'create',
					img: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/chuangzuotairukou-AIshangpinhaibao@2x.png',
					subLabel: '卖点自动排版突出',
					// 跳转校验
					check:'checkMemberStatus',
					menuIcon: 'AIshangpinhaibao',
				},
			},
			{
				name: 'AI商详页',
				path: '/create/product-details',
				component: './productDetail',
				meta: {
					hideNav: true,
					showWorkbench: true,
					hideBorder: true,
					crumb: 'create',
					img: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/chuangzuotairukou-AIshangxiangye@2x.png',
					subLabel: '一键生成省时省力',
					// 跳转校验
					check:'checkMemberStatus',
					menuIcon: 'AIshangxiangye',
				},
			},
			{
				name: 'AI创意海报',
				path: '/create/creativePoster',
				component: './creativePosters',
				meta: {
					hideNav: true,
					showWorkbench: true,
					hideBorder: true,
					crumb: 'create',
					img: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/chuangzuotairukou-AIchuangyihaibao@2x.png',
					subLabel: '灵感速成创意立现',
					menuIcon: 'CreativePoster',
				},
			},
			{
				name: 'AI试衣',
				path: '/create/tryClothes',
				component: './tryClothes',
				meta: {
					hideNav: true,
					showWorkbench: true,
					hideBorder: true,
					crumb: 'create',
					// showDropMenu:false,
					menuIcon: 'icon_AIshiyi',
					notNeedLogin:true,
          subLabel: '3秒生成百套穿搭',
          img: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/chuangzuotairukou-AIshiyi@2x.png'
				},
			},
      {
				name: 'AI换万物',
				path: '/create/changeEverything',
				component: './changeEverything',
				meta: {
					hideNav: true,
					showWorkbench: true,
					hideBorder: true,
					crumb: 'create',
					showDropMenu:false,
					menuIcon: 'huanwanwu2', // todo
				},
			},
			{
				name: 'AI营销写作',
				path: '/create/marketing-writing',
				component: './createWrite',
				meta: {
					hideNav: true,
					showWorkbench: true,
					hideBorder: true,
					crumb: 'create',
					img: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/chuangzuotairukou-AIyingxiaoxiezuo@2x.png',
					subLabel: '轻松get10万+爆文',
					menuIcon: 'AIyingxiaoxiezuo',
				},
			},
		],
	},
]
